import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M4.24512 8C4.24512 5.17157 4.24512 3.75736 5.1238 2.87868C6.00248 2 7.41669 2 10.2451 2H14.2451C17.0735 2 18.4878 2 19.3664 2.87868C20.2451 3.75736 20.2451 5.17157 20.2451 8V16C20.2451 18.8284 20.2451 20.2426 19.3664 21.1213C18.4878 22 17.0735 22 14.2451 22H10.2451C7.41669 22 6.00248 22 5.1238 21.1213C4.24512 20.2426 4.24512 18.8284 4.24512 16V8Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M20.1429 16H8.14289C7.21292 16 6.74794 16 6.36644 16.1022C5.33116 16.3796 4.52252 17.1883 4.24512 18.2235"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M8.24512 7H16.2451" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.24512 10.5H13.2451" stroke="#F59C53" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M4.24512 8C4.24512 5.17157 4.24512 3.75736 5.1238 2.87868C6.00248 2 7.41669 2 10.2451 2H14.2451C17.0735 2 18.4878 2 19.3664 2.87868C20.2451 3.75736 20.2451 5.17157 20.2451 8V16C20.2451 18.8284 20.2451 20.2426 19.3664 21.1213C18.4878 22 17.0735 22 14.2451 22H10.2451C7.41669 22 6.00248 22 5.1238 21.1213C4.24512 20.2426 4.24512 18.8284 4.24512 16V8Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M20.1429 16H8.14289C7.21292 16 6.74794 16 6.36644 16.1022C5.33116 16.3796 4.52252 17.1883 4.24512 18.2235"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M8.24512 7H16.2451" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.24512 10.5H13.2451" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default Icon;
